import request from '@/utils/request';
//医院产品指标清空接口
export function indicatorClearData(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/clearData',
    method: 'post',
    data
  });
}
//医院产品指标调整表头查询
export function indicatorColumn(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/column',
    method: 'get',
    params: data
  });
}
//医院产品指标删除接口
export function deleteHospitalProduct(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/deleteHospitalProduct',
    method: 'post',
    data
  });
}
//删除员工账号
export function deleteRepresentative(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/deleteRepresentative',
    method: 'post',
    data
  });
}

//医院产品指标调整编辑指标、备注

export function indicatorEdit(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/edit',
    method: 'post',
    data
  });
}

//员工账号查询接口
export function findRepresentative(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/findRepresentative',
    method: 'get',
    params: data
  });
}

//获取医院产品指标的列头
export function headInfo(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/headInfo',
    method: 'get',
    params: data
  });
}

//获取医院产品指标调整列表
export function listAdjust(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/listAdjust',
    method: 'post',
    data
  });
}

//医院产品指标调整总计
export function listAdjustTotal(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/adjustSum',
    method: 'post',
    data
  });
}

//获取医院产品指标列表

export function listData(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/listData',
    method: 'post',
    data
  });
}

//医院产品指标更新接口
export function updateHospitalProduct(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/updateHospitalProduct',
    method: 'post',
    data
  });
}

//设置员工账号接口
export function updateRepresentative(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/updateRepresentative',
    method: 'post',
    data
  });
}
//指标筛选字段的联动接口
export function indicatorColumnValue(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/column/value',
    method: 'get',
    params: data
  });
}

//指标调整筛选字段的联动接口
export function indicatorColumnValueAdjust(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/column/value/adjust',
    method: 'get',
    params: data
  });
}
//指标岗位匹配列表查询
export function deptMatch(data) {
  return request({
    url: '/adminapi/indicator/dept-match/page',
    method: 'post',
    data
  });
}

//指标岗位匹配清空指标
export function deptMatchClear(data) {
  return request({
    url: '/adminapi/indicator/dept-match/clear',
    method: 'post',
    data
  });
}

//指标岗位匹配表头查询

export function deptMatchColumn(data) {
  return request({
    url: '/adminapi/indicator/dept-match/column',
    method: 'get',
    params: data
  });
}

//指标下发接口
export function distribution(data) {
  return request({
    url: '/adminapi/indicator-distribution-config/distribution',
    method: 'post',
    data
  });
}

// 获取指标岗位匹配列表
export function getDeptMatch(data) {
  return request({
    url: '/adminapi/indicator/dept-match',
    method: 'get',
    params: data
  });
}

// 清空指标
export function clearDeptMatch(data) {
  return request({
    url: '/adminapi/indicator/dept-match/clear',
    method: 'post',
    data
  });
}

// 医院共坑岗位及比例的调整-列表
export function adjustCommonRatio(data) {
  return request({
    url: '/adminapi/indicator/dept-match/common-ratio',
    method: 'post',
    data
  });
}

// 删除指定岗位下的负责人
export function deleteInCharge(data) {
  return request({
    url: '/adminapi/indicator/dept-match/delete-in-charge',
    method: 'post',
    data
  });
}

// 获取生产力检查-DSM汇总-列表
export function getDSMSummary(data) {
  return request({
    url: '/adminapi/indicator/dept-match/dsm',
    method: 'get',
    params: data
  });
}

// 导出岗位指标匹配记录
export function exportDeptMatch(data) {
  return request({
    url: '/adminapi/indicator/dept-match/export',
    method: 'post',
    data
  });
}

// 获取生产力检查-MR汇总-列表
export function getMRSummary(data) {
  return request({
    url: '/adminapi/indicator/dept-match/mr',
    method: 'get',
    params: data
  });
}

// 变更指定岗位id的备注信息
export function updateRemark(data) {
  return request({
    url: '/adminapi/indicator/dept-match/remark',
    method: 'post',
    data
  });
}

// 代表岗位归属人 (转移代表岗位，将代表岗位ID移交到新的地区岗位ID下)
export function transferPosition(data) {
  return request({
    url: '/adminapi/indicator/dept-match/transfer',
    method: 'post',
    data
  });
}

// 医院共坑岗位及比例的调整
export function updateCommonRatio(data) {
  return request({
    url: '/adminapi/indicator/dept-match/update-common-ratio',
    method: 'post',
    data
  });
}

// 变更指定岗位id的负责人
export function updateInCharge(data) {
  return request({
    url: '/adminapi/indicator/dept-match/update-in-charge',
    method: 'post',
    data
  });
}

//地区经理岗位管理-列表查询
export function getRegionalManager(data) {
  return request({
    url: '/adminapi/indicator/dept/regional',
    method: 'post',
    data
  });
}

//代表岗位管理（汇报线）-列表查询
export function getRepresentative(data) {
  return request({
    url: '/adminapi/indicator/dept/representative',
    method: 'post',
    data
  });
}
//根据类型查询下发状态
export function searchDistributionConfig(data) {
  return request({
    url: '/adminapi/indicator-distribution-config/searchDistributionConfig',
    method: 'get',
    params: data
  });
}

//代表辖区和指标管理-日志列表
export function getLogs(data) {
  return request({
    url: '/adminapi/indicator/dept-match/logs',
    method: 'get',
    params: data
  });
}

//指标管理获取树形组织架构
export function getTree(data) {
  return request({
    url: '/adminapi/indicator-struct/tree',
    method: 'get',
    params: data
  });
}

//指标管理获取指定部门负责人
export function getUsersByDept(data) {
  return request({
    url: '/adminapi/indicator-struct/users/by-dept',
    method: 'get',
    params: data
  });
}

//账号列表查询
export function getUsers(data) {
  return request({
    url: '/adminapi/indicator-struct/users',
    method: 'get',
    params: data
  });
}

///指标岗位调整 根据指定视图名查询表头
export function getDeptColumns(data) {
  return request({
    url: '/adminapi/indicator/dept/columns',
    method: 'get',
    params: data
  });
}

//指标岗位列表查询
export function getDeptMatchPage(data) {
  return request({
    url: '/adminapi/indicator/dept-match/page',
    method: 'post',
    data
  });
}
// 指标导入
export function uploadTaskCreate(data) {
  return request({
    url: '/crmapi/upload-task/create',
    method: 'post',
    data
  });
}

// 指标岗位匹配具体表头查询
export function deptMatchColumnValue(data) {
  return request({
    url: '/adminapi/indicator/dept-match/column/value',
    method: 'get',
    params: data
  });
}

//医院产品指标调整表头查询
export function headInfoAdjust(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/headInfoAdjust',
    method: 'get',
    params: data
  });
}
//医院产品指标调整编辑指标
export function editAvgMonthAdjustIndicator(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/editAvgMonthAdjustIndicator',
    method: 'post',
    data
  });
}
//医院产品指标调整编辑备注
export function editRemark(data) {
  return request({
    url: '/adminapi/indicator-hospital-product/editRemark',
    method: 'post',
    data
  });
}

//导入状态查询
export function uploadTaskState(data) {
  return request({
    url: '/crmapi/upload-task/query/state',
    method: 'get',
    params: data
  });
}
//查询指定层级的岗位列表
export function getlistByLevel(data) {
  return request({
    url: '/adminapi/indicator-struct/list-by-level',
    method: 'get',
    params: data
  });
}

//登录人所在岗位层级信息
export function getLevel(data) {
  return request({
    url: '/adminapi/indicator/dept-match/level',
    method: 'get',
    params: data
  });
}

//岗位负责人列表查询
export function getRepresentatives(data) {
  return request({
    url: '/adminapi/indicator-struct/representatives',
    method: 'get',
    params: data
  });
}
//指标调整-获取表头
export function adjustColumn(data) {
  return request({
    url: '/adminapi/indicator/adjust/column',
    method: 'get',
    params: data
  });
}
//指标调整-获取列表
export function adjustDataList(data) {
  return request({
    url: '/adminapi/indicator/adjust/dataList',
    method: 'post',
    data
  });
}
//获取下个账期的岗位列表
export function nextFiscalDept(data) {
  return request({
    url: '/adminapi/indicator/adjust/nextFiscalDept',
    method: 'get',
    params: data
  });
}
//审批任务状态查询
export function submitCheck(data) {
  return request({
    url: '/adminapi/indicator/adjust/submitCheck',
    method: 'get',
    params: data
  });
}
// 指标调整提交
export function adjustSubmit(data) {
  return request({
    url: '/adminapi/indicator/adjust/submit',
    method: 'post',
    data
  });
}
// 指标调整提交按钮校验
export function submitCheckRule(data) {
  return request({
    url: '/adminapi/indicator/adjust/submitCheckRule',
    method: 'get',
    params: data
  });
}

//指标调整后汇总
export function adjustAfterSumApi(data) {
  return request({
    url: '/adminapi/indicator/adjust/adjustAfterSum',
    method: 'get',
    params: data
  });
}
// 指标调整汇总
export function adjustSumApi(data) {
  return request({
    url: '/adminapi/indicator/adjust/adjustSum',
    method: 'post',
    data
  });
}
//指标调整编辑
export function adjustEdit(data) {
  return request({
    url: '/adminapi/indicator/adjust/edit',
    method: 'post',
    data
  });
}
//指标调整编辑检查
export function adjustEditCheck(data) {
  return request({
    url: '/adminapi/indicator/adjust/editCheck',
    method: 'post',
    data
  });
}
